module.exports = __webpack_public_path__ + "img/select.30782d83.svg";